export default {
  methods: {
    getIndex (index) {
      const limmit = this.search.limit ??  this.pagination?.limit ??  this.search.pagination?.limmit ?? this.search.size ?? this.search.pagination?.size ?? this.search.pageSize
      const page = (this.search.page ?? this.pagination?.page ?? this.search.pagination?.page ?? this.search.pageIndex) - 1
      return limmit * page + index + 1
    }
  }
}
